<template>
  <div class="text-xs-center margin" style="height" :close-on-backdrop="true">
    <v-dialog
      v-model="calculatorVisible"
      class="card1 opacity"
      persistent
      max-width="none"
      overlay-opacity
      hide-overlay
      no-click-animation
      transition
      retain-focus
      open-delay
      open-on-focus
      content-class="my-custom-dialog"
    >
      <template v-slot:activator="{ on }">
        <div @click="opencal()">
          <slot>
            <v-btn> Calculator </v-btn>
          </slot>
        </div>
      </template>
      <VueDragResize
        :isActive="true"
        :x="0"
        :y="0"
        :h="0"
        :w="0"
        :minw="false"
        :stickSize="false"
        :sticks="false"
        :parentScaleY="0.5"
      >
        <div class="calculator card">
          <v-btn class="small" fab dark color="red" @click="onClose()">
            <v-icon dark> mdi-close </v-icon>
          </v-btn>

          <vue-number-input type="number" @click="input()" class="screen">{{
            currentCalculation || '0'
          }}</vue-number-input>
          <div @click="clear" class="btn1">C</div>
          <div @click="sign" class="btn1">+/-</div>
          <div @click="percent" class="btn1">%</div>
          <div @click="divide" class="btn operator">÷</div>
          <div @click="append('7')" class="btn">7</div>
          <div @click="append('8')" class="btn">8</div>
          <div @click="append('9')" class="btn">9</div>
          <div @click="times" class="btn operator">x</div>
          <div @click="append('4')" class="btn">4</div>
          <div @click="append('5')" class="btn">5</div>
          <div @click="append('6')" class="btn">6</div>
          <div @click="minus" class="btn operator">-</div>
          <div @click="append('1')" class="btn">1</div>
          <div @click="append('2')" class="btn">2</div>
          <div @click="append('3')" class="btn">3</div>
          <div @click="add" class="btn operator">+</div>
          <div @click="append('0')" class="btn zero">0</div>
          <div @click="dot" class="btn">.</div>
          <div @click="equal" class="btn operator">=</div>
        </div>
      </VueDragResize>
    </v-dialog>
  </div>
</template>

<script>
import VueDragResize from 'vue-drag-resize';
import { mapState } from 'vuex';

export default {
  name: 'DraggableDiv',
  name: 'app',

  components: {
    VueDragResize,
  },
  data: function () {
    return {
      previous: null,
      current: '',
      operator: null,
      operatorClicked: false,

      positions: {
        clientX: undefined,
        clientY: undefined,

        movementX: 0,
        movementY: 0,
      },
    };
  },
  computed: {
    ...mapState(['calculatorVisible']),
    ...mapState(['currentCalculation']),
  },
  methods: {
    dragMouseDown: function (event) {
      event.preventDefault();
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },
    elementDrag: function (event) {
      event.preventDefault();
      this.positions.movementX = this.positions.clientX - event.clientX;
      this.positions.movementY = this.positions.clientY - event.clientY;
      this.positions.clientX = event.clientX;
      this.positions.clientY = event.clientY;
      // set the element's new position:
      this.$refs.draggableContainer.style.top =
        this.$refs.draggableContainer.offsetTop -
        this.positions.movementY +
        'px';
      this.$refs.draggableContainer.style.left =
        this.$refs.draggableContainer.offsetLeft -
        this.positions.movementX +
        'px';
    },
    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },

    opencal() {
      this.$store.dispatch('setCaluclatorSettings', true);

      //this.dialog=true;
    },
    onClose() {
      this.$store.dispatch('setCaluclatorSettings', false);
      this.$store.dispatch('setCurrentCalculation', 0);
      this.show = false;
    },

    draggableCards() {},
    clear() {
      this.current = '';
      this.$store.dispatch('setCurrentCalculation', this.current);
    },
    sign() {
      this.current =
        this.current.charAt(0) === '-'
          ? this.current.slice(1)
          : `-${this.current}`;
      this.$store.dispatch('setCurrentCalculation', this.current);
    },
    percent() {
      this.current = `${parseFloat(this.current) / 100}`;
    },
    append(number) {
      if (this.operatorClicked) {
        this.current = '';
        this.operatorClicked = false;
      }
      this.current = `${this.current}${number}`;
      this.$store.dispatch('setCurrentCalculation', this.current);
    },
    dot() {
      if (this.current.indexOf('.') === -1) {
        this.append('.');
      }
    },
    setPrevious() {
      this.previous = this.currentCalculation;
      this.operatorClicked = true;
    },
    divide() {
      this.operator = (a, b) => b / a;
      this.setPrevious();
    },
    times() {
      this.operator = (a, b) => a * b;
      this.setPrevious();
    },
    minus() {
      this.operator = (a, b) => b - a;
      this.setPrevious();
    },
    add() {
      this.operator = (a, b) => a + b;
      this.setPrevious();
    },
    equal() {
      this.current = `${this.operator(
        parseFloat(this.current),
        parseFloat(this.previous),
      )}`;
      this.$store.dispatch('setCurrentCalculation', this.current);
      this.previous = null;
    },
  },
};
// Select all the from document using queryselectAll
var keys = document.querySelectorAll('#calculator span');
// Define operators
var operators = ['+', '-', 'x', '÷', '^'];
// Set decimal flag for use later
var decimalAdded = false;

// loop through all keys
for (var i = 0; i < keys.length; i++) {
  //add onclick event to the keys
  keys[i].onclick = function (e) {
    // Get the input and button values
    var input = document.querySelector('.screen');
    var inputVal = input.innerHTML;
    var btnVal = this.innerHTML;

    // If clear key is pressed, erase everything
    if (btnVal == 'C') {
      input.innerHTML = '';
      decimalAdded = false;
    }

    // If eval key is pressed, calculate and display the result
    else if (btnVal == '=') {
      var equation = inputVal; //append equation to variable
      var lastChar = equation[equation.length - 1]; //target the end of the eval string

      // Use regex to replace all instances of x, ÷, ^ with *, / and **
      equation = equation
        .replace(/x/g, '*')
        .replace(/÷/g, '/')
        .replace(/\^/g, '\*\*');

      //Use regex to remove decimals from the end of an equation
      if (operators.indexOf(lastChar) > -1 || lastChar == '.')
        equation = equation.replace(/.$/, '');

      // use javascript's eval function to get the result

      if (equation) input.innerHTML = eval(equation);
      decimalAdded = false;
    }

    // Javascript checks

    // No two operators should be added consecutively.
    else if (operators.indexOf(btnVal) > -1) {
      // Get the last character from the equation
      var lastChar = inputVal[inputVal.length - 1];

      // Only add operator if input is not empty
      if (inputVal != '' && operators.indexOf(lastChar) == -1)
        input.innerHTML += btnVal;
      // Allow minus operator if the string is empty
      else if (inputVal == '' && btnVal == '-') input.innerHTML += btnVal;

      // Replace the last operator (if exists) with the newly pressed operator
      if (operators.indexOf(lastChar) > -1 && inputVal.length > 1) {
        input.innerHTML = inputVal.replace(/.$/, btnVal);
      }

      decimalAdded = false;
    }
    // allow decimal point input
    else if (btnVal == '.') {
      if (!decimalAdded) {
        input.innerHTML += btnVal;
        decimalAdded = true;
      }
    }

    // if any other key is pressed, just append it after the decimal
    else {
      input.innerHTML += btnVal;
    }

    // prevent page jumps
    e.preventDefault();
  };
}

//adding keyboard input functionality
// document.onkeydown = function(event) {
//   var key_press = String.fromCharCode(event.keyCode);
//   var key_code = event.keyCode;
//   var input = document.querySelector(".screen");
//   var inputVal = input.innerHTML;
//   var btnVal = this.innerHTML;
//   var lastChar = inputVal[inputVal.length - 1];
//   var equation = inputVal;
//   // Using regex to replace all instances of x, ÷, ^ with *, / and ** respectively.
//   equation = equation
//     .replace(/x/g, "*")
//     .replace(/÷/g, "/")
//     .replace(/\^/g, "**");

//   // Target each keypress and update the input screen

//   if (key_press == 1) {
//     input.innerHTML += key_press;
//   }
//   if (key_press == 2) {
//     input.innerHTML += key_press;
//   }
//   if (key_press == 3 || key_code == 32) {
//     input.innerHTML += key_press;
//   }
//   if (key_press == 4) {
//     input.innerHTML += key_press;
//   }
//   if (key_press == 5) {
//     input.innerHTML += key_press;
//   }
//   if (key_press == 6 && event.shiftKey == false) {
//     input.innerHTML += key_press;
//   }
//   if (key_press == 7) {
//     input.innerHTML += key_press;
//   }
//   if (key_press == 8 && event.shiftKey == false) {
//     input.innerHTML += key_press;
//   }
//   if (key_press == 9) {
//     input.innerHTML += key_press;
//   }
//   if (key_press == 0) {
//     input.innerHTML += key_press;
//   }

//   // Cature operators and prevent from addint two consecutuve operators

//   if (
//     (inputVal != "" &&
//       operators.indexOf(lastChar) == -1 &&
//       key_code == 187 &&
//       event.shiftKey) ||
//     key_code == 107 ||
//     (key_code == 61 && event.shiftKey)
//   ) {
//     document.querySelector(".screen").innerHTML += "+";
//   }
//   if (
//     (inputVal != "" &&
//       operators.indexOf(lastChar) == -1 &&
//       key_code == 189 &&
//       event.shiftKey) ||
//     (inputVal != "" && operators.indexOf(lastChar) == -1 && key_code == 107)
//   ) {
//     document.querySelector(".screen").innerHTML += "-";
//   }
//   if (
//     (inputVal != "" &&
//       operators.indexOf(lastChar) == -1 &&
//       key_code == 56 &&
//       event.shiftKey) ||
//     (inputVal != "" && operators.indexOf(lastChar) == -1 && key_code == 106)
//   ) {
//     document.querySelector(".screen").innerHTML += "x";
//   }
//   if (
//     (inputVal != "" && operators.indexOf(lastChar) == -1 && key_code == 191) ||
//     (inputVal != "" && operators.indexOf(lastChar) == -1 && key_code == 111)
//   ) {
//     document.querySelector(".screen").innerHTML += "÷";
//   }
//   if (
//     inputVal != "" &&
//     operators.indexOf(lastChar) == -1 &&
//     key_code == 54 &&
//     event.shiftKey
//   ) {
//     document.querySelector(".screen").innerHTML += "^";
//   }
//   if (key_code == 13 || (key_code == 187 && event.shiftKey == false)) {
//     input.innerHTML = eval(equation);
//     //reset decimal added flag
//     decimalAdded = false;
//   }
//   if (key_code == 8 || key_code == 46) {
//     input.innerHTML = "";
//     decimalAdded = false;
//   }
// };
</script>

<style scoped>
.calculator {
  margin: 0 auto;
  font-size: 40px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(50px, auto);
  text-align: center;
  opacity: 1.5;
}
.screen {
  margin-bottom: 50px;
  text-align: right;
  padding: 10px;
  grid-column: 1 / 5;
  background-color: #31322e;
  color: aliceblue;
  width: 230px;
  height: 160px;
  border: 1px solid rgba(0, 0, 0, 0.198);
  border-radius: 10px;
}
.zero {
  grid-column: 1 / 3;
}
.btn {
  background-color: hsl(280deg 1% 49%);
  border: 1px solid #999;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.198);
  padding-top: 10px;
}
.btn1 {
  background-color: #464442;
  border: 1px solid #646362;
  border: 1px solid rgba(0, 0, 0, 0.198);
  padding-top: 10px;
}
.operator {
  background-color: #f2a33c;
  color: white;
}
.card {
  margin-top: 0px;
  margin-left: 1200px;
  width: 230px;
  height: 350px;
  font-size: 20px;
  text-align: center;
  color: white;
  overflow: hidden;
  grid-column: 2 / -1;
  border-radius: 10px;
}

.Draggable {
  margin-top: 500px;
}

.close {
  margin-right: 10px;
}

.small {
  width: 20px;
  height: 20px;
  margin-top: 40px;
}

.v-dialog {
  width: 0%;
}
.card1 {
  opacity: 0;
  display: none;
  opacity: 0;
}

#draggable-container {
  position: absolute;
}
#draggable-header {
  opacity: 1.5;

  margin-left: 850px;
}
.blue {
  width: 20px;
  height: 20px;
  margin-bottom: -118px;
  margin-left: 15px;
}

.v-overlay__scrim {
  opacity: 0;
  background-color: rgb(201, 83, 83);
  border-color: rgb(41, 165, 37);
}

.v-dialog__content {
  z-index: 20002 !important;
}

.vdr.active:before {
  outline: 1px dashed #fdfcfc;
  width: 10%;
  height: 100%;
}
</style>
